import zhTw from 'element-plus/es/locale/lang/zh-tw'

import { adminTraditionalChineseMessages } from '../catalogs/zh-TW'
import { defineAdminLocale } from '../locale-definition'

export default defineAdminLocale({
  code: 'zh-TW',
  name: '繁體中文',
  order: 20,
  elementPlusLocale: zhTw,
  messages: adminTraditionalChineseMessages
})
